<script>
  import {  Col, Container, Form, Row, } from 'sveltestrap';
  import Card from '../../Core/Card.svelte';
  import DefaultRangeSlider from './DefaultRangeSlider.svelte';
  import PipsLabel from './PipsLabel.svelte';
  import RangeSliderWithPips from './RangeSliderWithPips.svelte';
  import MinMaxRange from "./MinMaxRange.svelte"
  import Bindthevalue from './Bindthevalue.svelte';
  import MultipleValues from './MultipleValues.svelte';
  import CustomLable from './CustomLable.svelte';
  import Prefix from './Prefix.svelte';
  import Suffix from './Suffix.svelte';
  import ValueBounds from './ValueBounds.svelte';
  import BookmarkRangSlider from './BookmarkRangSlider.svelte';
  import { IconRangeSlider } from '../../../utils/Constant/Constant';
</script>
<BookmarkRangSlider />
<Container fluid >
  <Row>
    <Col sm="12">
      <Card headerTitle={IconRangeSlider} cardHeaderprops="pb-0">
        <div slot="contentbody" class="range-sliders">
          <Form className="theme-form form-label-align-right range-slider">
            <DefaultRangeSlider />
            <RangeSliderWithPips />
            <PipsLabel />
            <MinMaxRange />
            <Bindthevalue />
            <MultipleValues />
            <CustomLable />
            <Prefix />
            <Suffix />
            <ValueBounds />
          </Form>
        </div>
      </Card>
    </Col>
  </Row>
</Container>
